import http from './http.service';

class ParticipantService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/participant";
    }

    get(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/${id}`);
    };

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getForEdit/${id}`);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}`, model);
    };

    updateMultiple(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateMultiple`, model);
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}`, model);
    };

    getParticipationDetailsById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getParticipationDetailsById/${id}`);
    }

    updateParticipationDetails(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateParticipationDetails`, model);
    }

    deleteConfirmationRejection(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteConfirmationRejection`, { params: { id: id, eventId: eventId } });
    }

    notifySelected(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/notifySelected`, model);
    }
}

export default new ParticipantService();
